import React from "react";
import GeneralButtonWithText from "../helpers/GeneralButtonWithText";
import { UIProperties } from "../UIProperties";

const ConfirmAlert = (props: UIProperties<ConfirmAlertProps>) => {
	return (<div className="modal-bg" style={{
				position: 'absolute',
				top: '0',
				left: '0',
				width: '100%',
				height: '100%'
			}}>
				<div style={{
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '100%',
					padding: '30px'
				}}>
					<p className="regular-description-font" style={{
						margin: '0px',
						left: '0',
						textAlign: 'center',
						width: '100%',
						fontSize: '50pt'
					}} tabIndex={0} id='confirm-alert-first-object'>{props.parameters.text}</p>
					<div style={{
						position: 'relative',
						height: '100px',
						top: '20px'
					}}>
						<GeneralButtonWithText parameters= {{
							text: props.parameters.yesBttnText ? props.parameters.yesBttnText : 'Yes',
							top: '0',
							left: '480px',
							width: '215px',
							onClicked: () => {
								props.parameters.onYes();
							}
						}}/>

						<GeneralButtonWithText parameters= {{
							id: 'confirm-alert-last-object',
							text: props.parameters.noBttnText ? props.parameters.noBttnText : 'No',
							top: '0',
							left: '1150px',
							width: '215px',
							onClicked: () => {
								props.parameters.onNo();
							}
						}}/>
					</div>
					
					
				</div>
		</div>)
}

export interface ConfirmAlertProps {
	text: string;
	onYes: () => void;
	onNo: () => void;
	yesBttnText?: string,
	noBttnText?: string
}

export default ConfirmAlert;